module.exports = __webpack_public_path__ + "img/map2_b.fd58b44d.svg";